import { Component, inject } from '@angular/core';
import { MaskitoOptions } from '@maskito/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { InternalUserAuthViewModel } from '../../../../viewModels/internal-user-auth-view-model.service';
import { AuthCodeRequest } from '../../../../../../models/users/requests/auth-code-request';
import { InternalUser } from '../../../../../../models/users/dto/internal-user';
import { SessionService } from '../../../../../../services/session-service';
import { NumberUtils } from '../../../../../../utils/number-utils';
import { createVerificationCodeFormGroup } from '../../../../forms/verification-code-form-group';

@Component({
  selector: 'app-internal-user-verify-code',
  templateUrl: './internal-user-verify-code.component.html',
  styleUrls: ['./internal-user-verify-code.component.scss', '../../auth.component.scss']
})
export class InternalUserVerifyCodeComponent extends BaseComponent {
  viewModel = inject(InternalUserAuthViewModel);

  constructor(private sessionService: SessionService) {
    super();
  }

  req = new AuthCodeRequest('', '', null, '');

  public formGroup = createVerificationCodeFormGroup();
  public formSubmitted = false;

  public readonly codeMaskOptions: MaskitoOptions = {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
  };

  public customErrorMessages = {
    code: {
      exactLength: $localize`Verification code must be 6 digits`
    }
  };

  public submit(): void {
    this.formSubmitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.viewModel.verifyMfaCode(
      {
        ...this.req,
        timeBasedOneTimePassword: NumberUtils.formatNumberWithLeadingZeros(+this.formGroup.controls.code.value, 6)
      },
      false
    );
  }

  setupBindings(): void {
    this.sessionService.sessionContainer$.notNull().once(session => {
      if (!session) session = this.viewModel.getCachedSession();
      const user = session?.user as InternalUser;
      this.req.challengeName = user.challengeName ?? null;
      this.req.sessionId = user.sessionId ?? '';
      this.req.email = user.email ?? '';
    });
  }

  setupViews(): void {}
}
